
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Stylelint`}</h2>
    <p>{`Lint your `}<a parentName="p" {...{
        "href": "https://github.com/styled-components/styled-components"
      }}>{`styled components`}</a>{` with `}<a parentName="p" {...{
        "href": "http://stylelint.io/"
      }}>{`stylelint`}</a>{`!`}</p>
    <h3>{`Installation`}</h3>
    <p>{`You need:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`stylelint`}</inlineCode></li>
      <li parentName="ul">{`The `}<a parentName="li" {...{
          "href": "https://github.com/styled-components/stylelint-processor-styled-components"
        }}>{`stylelint-processor-styled-components`}</a>{`, to extract styles from `}<inlineCode parentName="li">{`styled-components`}</inlineCode></li>
      <li parentName="ul">{`The `}<a parentName="li" {...{
          "href": "https://github.com/styled-components/stylelint-config-styled-components"
        }}><inlineCode parentName="a">{`stylelint-config-styled-components`}</inlineCode></a>{` to disable stylelint rules that clash with `}<inlineCode parentName="li">{`styled-components`}</inlineCode></li>
      <li parentName="ul">{`Your favorite `}<inlineCode parentName="li">{`stylelint`}</inlineCode>{` config! (for example `}<a parentName="li" {...{
          "href": "https://github.com/stylelint/stylelint-config-recommended"
        }}><inlineCode parentName="a">{`stylelint-config-recommended`}</inlineCode></a>{`)`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`We recommend using Stylelint v9+ as this has added features that allow us to report correct line numbers on CSS syntax errors`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{}}>{`(npm install --save-dev \\
  stylelint \\
  stylelint-processor-styled-components \\
  stylelint-config-styled-components \\
  stylelint-config-recommended)
`}</code></pre>
    <h3>{`Setup`}</h3>
    <p>{`Add a `}<inlineCode parentName="p">{`.stylelintrc`}</inlineCode>{` file to the root of your project:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-JSON"
      }}>{`{
  "processors": [
    "stylelint-processor-styled-components"
  ],
  "extends": [
    "stylelint-config-recommended",
    "stylelint-config-styled-components"
  ]
}
`}</code></pre>
    <p>{`Then you need to run `}<inlineCode parentName="p">{`stylelint`}</inlineCode>{`. Add a `}<inlineCode parentName="p">{`lint:css`}</inlineCode>{` script to your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` which runs `}<inlineCode parentName="p">{`stylelint`}</inlineCode>{` with a glob to all of your styled components:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-JSON"
      }}>{`{
  "scripts": {
    "lint:css":"stylelint './src/**/*.js'"
  }
}
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`The processor ignores javascript files that don't contain any `}<inlineCode parentName="p">{`styled-components`}</inlineCode>{`, so don't worry about being too broad as long as you restrict it to javascript (or TypeScript).`}</p>
    </blockquote>
    <p>{`Now you can lint your CSS by running the script! 🎉`}</p>
    <pre><code parentName="pre" {...{}}>{`npm run lint:css
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`Beware that due to limitations on what is possible for Stylelint custom processors we cannot support the `}<inlineCode parentName="p">{`--fix`}</inlineCode>{` option`}</p>
    </blockquote>
    <h4>{`Webpack`}</h4>
    <p>{`If you want to lint on build, rather than as a separate command, you can use the `}<a parentName="p" {...{
        "href": "https://github.com/emilgoldsmith/stylelint-custom-processor-loader"
      }}><inlineCode parentName="a">{`stylelint-custom-processor-loader`}</inlineCode></a>{` for webpack.`}</p>
    <h3><inlineCode parentName="h3">{`stylelint-config-styled-components`}</inlineCode></h3>
    <p>{`When using this processor a couple of stylelint rules throw errors that cannot be prevented, like `}<a parentName="p" {...{
        "href": "https://stylelint.io/user-guide/rules/no-empty-source"
      }}><inlineCode parentName="a">{`no-empty-source`}</inlineCode></a>{` or `}<a parentName="p" {...{
        "href": "https://stylelint.io/user-guide/rules/no-missing-end-of-source-newline"
      }}><inlineCode parentName="a">{`no-missing-end-of-source-newline`}</inlineCode></a>{`. There's also a couple rules which we need to enforce, like `}<a parentName="p" {...{
        "href": "https://stylelint.io/user-guide/rules/property-no-vendor-prefix"
      }}><inlineCode parentName="a">{`no-vendor-prefix`}</inlineCode>{` rules`}</a>{`. (`}<inlineCode parentName="p">{`styled-components`}</inlineCode>{` automatically vendor prefixes your code, so you don't need to do it manually)`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://github.com/styled-components/stylelint-config-styled-components"
      }}><inlineCode parentName="a">{`stylelint-config-styled-components`}</inlineCode></a>{` will automatically disable rules that cause conflicts.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You can override rules defined in shared configs in your custom `}<inlineCode parentName="p">{`.stylelintrc`}</inlineCode>{`.`}</p>
    </blockquote>
    <h3>{`Usage with other libraries`}</h3>
    <p>{`Some other libraries also implement the `}<inlineCode parentName="p">{`styled.x`}</inlineCode>{` pattern with tagged template literals. This processor will lint the CSS in those tagged template literals too, as long as they use the `}<inlineCode parentName="p">{`styled`}</inlineCode>{` keyword.`}</p>
    <p>{`If you want to use the processor with another library but you also want to change the keyword (e.g. to write `}<inlineCode parentName="p">{`cool.div`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`styled.div`}</inlineCode>{`) use the `}<inlineCode parentName="p">{`moduleName`}</inlineCode>{` option:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import cool from 'other-library'

const Button = cool.button\`
  color: blue;
\`
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "processors": [
    [
      "stylelint-processor-styled-components",
      {
        "moduleName": "other-library"
      }
    ]
  ]
}
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`That double array is on purpose but only necessary if you set options, see the `}<a parentName="p" {...{
          "href": "https://stylelint.io/user-guide/configuration/#processors"
        }}>{`processors configuration docs`}</a>{`.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`We only officially support `}<inlineCode parentName="p">{`styled-components`}</inlineCode>{`, but the hope is that other libraries can also benefit from the processor.`}</p>
    </blockquote>
    <h3>{`Interpolation tagging`}</h3>
    <p>{`Sometimes `}<inlineCode parentName="p">{`stylelint`}</inlineCode>{` can throw an error (e.g. `}<inlineCode parentName="p">{`CssSyntaxError`}</inlineCode>{`) even though nothing is wrong with your CSS. This is often due to an interpolation, more specifically the fact that the processor doesn't know what you're interpolating.`}</p>
    <p>{`A simplified example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const something = 'background'

const Button = styled.div\`
  \${something}: papayawhip;
\`
`}</code></pre>
    <p>{`When you have interpolations in your styles the processor can't know what they are, so it makes a good guess and replaces them with a syntactically equivalent placeholder value. Since `}<inlineCode parentName="p">{`stylelint`}</inlineCode>{` is not a code flow analysis tool this doesn't cover all edge cases and the processor will get it wrong every now and then.`}</p>
    <p>{`Interpolation tagging allows you to tell the processor what an interpolation is in case it guesses wrong; it can then replace the interpolation with a syntactically correct value based on your tag.`}</p>
    <p>{`For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const something = 'background'

const Button = styled.div\`
  // Tell the processor that "something" is a property
  \${/* sc-prop */ something}: papayawhip;
\`
`}</code></pre>
    <p>{`Now the processor knows that the `}<inlineCode parentName="p">{`something`}</inlineCode>{` interpolation is a property, and it can replace the interpolation with a property for linting.`}</p>
    <p>{`To tag an interpolation add a comment at either the start or the end of the interpolation. (`}<inlineCode parentName="p">{`\${/* sc-tag */ foo}`}</inlineCode>{` or `}<inlineCode parentName="p">{`\${bar /* sc-tag */}`}</inlineCode>{`) Tags start with `}<inlineCode parentName="p">{`sc-`}</inlineCode>{` and, if specified, a tag overrides the processors guess about what the interpolation is.`}</p>
    <h4>{`Tags`}</h4>
    <p>{`The full list of supported tags:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`sc-block`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`sc-selector`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`sc-declaration`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`sc-property`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`sc-value`}</inlineCode></li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If you are in doubt of the vocabulary you can refer to `}<a parentName="p" {...{
          "href": "http://apps.workflower.fi/vocabs/css/en"
        }}>{`this CSS vocabulary list`}</a>{` with examples.`}</p>
    </blockquote>
    <p>{`For example, when you interpolate another styled component, what you really interpolate is its unique selector. Since the processor doesn't know that, you can tell it to replace it with a selector when linting:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const Wrapper = styled.div\`
  \${/* sc-selector */ Button} {
    color: red;
  }
\`
`}</code></pre>
    <p>{`You can also use shorthand tags to avoid cluttering the code. For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const Wrapper = styled.div\`
  \${/* sc-sel */ Button} {
    color: red;
  }
\`
`}</code></pre>
    <h5><inlineCode parentName="h5">{`sc-custom`}</inlineCode></h5>
    <p><strong parentName="p"><inlineCode parentName="strong">{`sc-custom`}</inlineCode>{` is meant to be used as a last resort escape hatch. Prefer to use the standard tags if possible!`}</strong></p>
    <p>{`On top of the above standard tags the processor also has the `}<inlineCode parentName="p">{`sc-custom`}</inlineCode>{` tag to allow you to cover more unique and uncommon edge cases. With the `}<inlineCode parentName="p">{`sc-custom`}</inlineCode>{` tag you can decide yourself what the placeholder value will be.`}</p>
    <p>{`For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Switch between left and right based on language settings passed through via the theme
const rtlSwitch = props => (props.theme.dir === 'rtl' ? 'left' : 'right')

const Button = styled.button\`
  background: green;
  // Tell the processor to replace the interpolation with "left"
  // when linting
  margin-\${/* sc-custom "left" */ rtlSwitch}: 12.5px;
\`
`}</code></pre>
    <h3>{`Syntax notes`}</h3>
    <h4>{`Turning rules off from within your JS/CSS`}</h4>
    <p>{`Turn off rules with `}<inlineCode parentName="p">{`stylelint-disable`}</inlineCode>{` comments (see the `}<a parentName="p" {...{
        "href": "https://stylelint.io/user-guide/configuration/#turning-rules-off-from-within-your-css"
      }}>{`stylelint documentation`}</a>{` for all allowed syntax) both inside and outside of the tagged template literals.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React from 'react'
import styled from 'styled-components'

// Disable stylelint from within the tagged template literal
const Wrapper = styled.div\`
  /* stylelint-disable */
  background-color: 123;
\`

// Or from the JavaScript around the tagged template literal
/* stylelint-disable */
const Wrapper = styled.div\`
  background-color: 123;
\`
`}</code></pre>
    <h4>{`Template literal style and indentation`}</h4>
    <p>{`In order to have stylelint correctly apply indentation rules the processor needs to do a bit of opinionated preprocessing on the styles, which results in us only officially supporting one indentation style. (the supported style is the "default" one as shown in all the documentation)`}</p>
    <p>{`The important thing is that you put the closing backtick on the base level of indentation as follows:`}</p>
    <p><strong parentName="p">{`Right`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`if (condition) {
  const Button = styled.button\`
    color: red;
  \`
}
`}</code></pre>
    <p><strong parentName="p">{`Wrong`}</strong></p>
    {
      /* prettier-ignore-start */
    }
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`if (condition) {
  const Button = styled.button\`
    color: red;
\`
}
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`if (condition) {
  const Button = styled.button\`
    color: red;\`
}
`}</code></pre>
    {
      /* prettier-ignore-end */
    }
    <p>{`It may be that other tagged template literal styles are coincidentally supported, but no issues will be handled regarding indentation unless the above style was used.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;